<template>
    <div class="ai-chat-wrapper" :class="{'full-screen1': isScreen}">
        <!-- 聊天框主体 -->
        <div v-show="isOpen" ref="aiChatPanel" class="aiChat" :class="{'full-screen': isScreen}" :style="chatPanelStyle">
            <div class="chat-container" :class="{'chat-container-screen': isScreen}">
                <!-- 头部（非全屏时可拖拽移动窗口） -->
                <div class="chat-header" :class="{'chat-header--draggable': !isScreen}" @mousedown="startDrag">
                    <div class="header-left">
                        <h2>飞凡智问</h2>
                        <!-- 对话历史记录入口 -->
                        <span @mousedown.stop @click="toggleHistory" class="icon el-icon-chat-line-square history-button" :class="{'is-active': showHistory}" title="对话历史"></span>
                    </div>
                    <div class="header-right">
                        <span @mousedown.stop @click="startNewChat" class="icon el-icon-plus history-button" title="新对话"></span>
                        <span @mousedown.stop @click="clearMessages" class="icon el-icon-delete clear-button" title="清除当前对话"></span>
                        <span @mousedown.stop @click="toggleFullScreen" class=" icon el-icon-full-screen minimize-button"></span>
                        <button style="margin-left: 5px;" type="button" @mousedown.stop @click="toggleChat" class="minimize-button">
                            X
                        </button>
                    </div>
                </div>

                <!-- 对话历史面板（覆盖在消息区域上方） -->
                <div v-show="showHistory" class="history-panel">
                    <div class="history-panel-header">
                        <span class="history-back" @click="toggleHistory" title="返回">
                            <i class="el-icon-back"></i>
                        </span>
                        <span class="history-title">对话历史</span>
                        <span class="history-new" @click="startNewChat" title="新建对话">
                            <i class="el-icon-plus"></i>
                        </span>
                    </div>
                    <div class="history-search">
                        <i class="el-icon-search"></i>
                        <input type="text" v-model="searchQuery" placeholder="搜索对话..." class="history-search-input">
                    </div>
                    <div class="history-list" v-loading="conversationsLoading">
                        <div
                            v-for="conv in filteredConversations"
                            :key="conv.id"
                            class="history-item"
                            :class="{'is-active': currentConversationId === conv.id}"
                            @click="switchConversation(conv)"
                        >
                            <div class="history-item-info">
                                <i class="el-icon-chat-dot-round history-item-icon"></i>
                                <div class="history-item-text">
                                    <div class="history-item-name">{{ conv.name || '新对话' }}</div>
                                    <div class="history-item-time">{{ formatConvTime(conv.updated_at || conv.created_at) }}</div>
                                </div>
                            </div>
                            <span class="history-item-del" @click.stop="deleteConversation(conv)" title="删除">
                                <i class="el-icon-delete"></i>
                            </span>
                        </div>
                        <div v-if="!conversationsLoading && conversations.length === 0" class="history-empty">
                            <i class="el-icon-chat-dot-round"></i>
                            <span>暂无对话记录</span>
                        </div>
                    </div>
                </div>

                <!-- 消息区域 -->
                <div class="chat-messages" v-show="!showHistory">
                    <!-- 系统消息 -->
                    <div v-if="msgList.length === 0" class="system-message">
                        你好！我是飞凡智问，有什么可以帮你的吗？
                    </div>

                    <!-- 消息列表 -->
                    <div v-for="(item, index) in msgList" :key="index" class="message-group">
                        <!-- 用户消息 -->
                        <div v-if="item.isUser" class="message user-message">
                            <div class="message-content">
                                {{ item.content }}
                            </div>
                        </div>
                        <!-- AI消息 -->
                        <div v-else class="message ai-message">
                            <div class="message-content ai-content-wrapper" style="padding-left:20px;">
                                <div v-if="item.isLoading" class="loading-indicator">
                                    <span class="loading-dot"></span>
                                    <span class="loading-dot"></span>
                                    <span class="loading-dot"></span>
                                </div>
                                <div v-else v-html="parseMarkdown(item.content)"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 输入区域 -->
                <div class="chat-input-area">
                    <div class="input-container">
                        <textarea v-model="queryMsg" placeholder="请输入问题..." class="chat-input" @keyup.enter.exact="getMsg"></textarea>
                    </div>
                    <button v-if="isCanSend" type="button" @click="getMsg" class="send-button">
                        <span class="iconfont icon el-icon-top"></span>
                    </button>
                    <div v-else class="send-button">
                        <span class="iconfont icon el-icon-loading"></span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 触发按钮 -->
        <button type="button" @click="toggleChat" class="chat-trigger">
            <span class="iconfont icon el-icon-message"></span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'aiChatMange',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.isOpen = newVal;
            }
        }
    },
    data() {
        return {
            queryMsg: '',
            isCanSend: true,
            msgList: [],
            md: null,
            isOpen: false,
            isScreen: false,
            /** 小窗口位置：null 表示使用默认右下角锚点 */
            panelPos: null,
            dragging: false,
            userId: '',
            dragStart: { x: 0, y: 0 },
            panelStart: { left: 0, top: 0 },
            // ===== 对话历史相关 =====
            /** 当前会话 ID（发送消息时携带，实现连续对话） */
            conversationId: '',
            /** 当前选中的会话 ID（用于 UI 高亮） */
            currentConversationId: '',
            /** 会话列表 */
            conversations: [],
            /** 是否显示历史面板 */
            showHistory: false,
            /** 会话列表加载状态 */
            conversationsLoading: false,
            /** 历史搜索关键字 */
            searchQuery: ''
        }
    },
    computed: {
        chatPanelStyle() {
            if (this.isScreen) {
                return {};
            }
            if (this.panelPos) {
                return {
                    left: `${this.panelPos.left}px`,
                    top: `${this.panelPos.top}px`,
                    right: 'auto',
                    bottom: 'auto'
                };
            }
            return {
                right: '30px',
                bottom: '20px',
                left: 'auto',
                top: 'auto'
            };
        },
        /** 过滤后的会话列表 */
        filteredConversations() {
            if (!this.searchQuery.trim()) return this.conversations;
            const kw = this.searchQuery.trim().toLowerCase();
            return this.conversations.filter(c => (c.name || '新对话').toLowerCase().includes(kw));
        }
    },
    mounted() {
        // 初始化用户信息
        this.getUserInfo();
        // 初始化markdown-it
        if (window.markdownit) {
            this.md = window.markdownit({
                html: true,
                linkify: true,
                breaks: true
            });
        }
        // 加载会话历史列表
        this.loadConversations();
        // 弹窗打开时滚动到底部
        this.$nextTick(() => {
            this.scrollToBottom();
        });
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
        document.body.style.userSelect = '';
    },
    methods: {
        // 获取用户信息
        getUserInfo() {
            var info = sessionStorage.getItem("userInfo");
            if (info) {
                const opmId = JSON.parse(info).opmId;
                this.userId = this.BASE_URL + '-' + 'aiChatMange' + '-' + opmId;
            }
        },  
        // ===== 对话历史管理 =====
        // 获取请求头
        getChatHeaders() {
            return {
                "Authorization": `Bearer ${window.global_config.AI_API.CHAT_API_KEY}`,
                'Content-Type': 'application/json'
            };
        },
        // 获取 API 基础 URL
        getChatBaseUrl() {
            return `${window.global_config.AI_CHAT_URL}/v1`;
        },
        // 切换历史面板显示
        toggleHistory() {
            this.showHistory = !this.showHistory;
            if (this.showHistory) {
                this.loadConversations();
            }
        },
        // 获取会话列表
        async loadConversations() {
            this.conversationsLoading = true;
            try {
                const params = new URLSearchParams({
                    user: this.userId,
                    limit: '50'
                });
                const response = await fetch(`${this.getChatBaseUrl()}/conversations?${params}`, {
                    method: 'GET',
                    headers: this.getChatHeaders()
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                this.conversations = data.data || [];
            } catch (error) {
                console.error('获取会话列表失败:', error);
            } finally {
                this.conversationsLoading = false;
            }
        },
        // 获取指定会话的消息历史
        async loadConversationMessages(conversationId) {
            if (!conversationId) {
                this.msgList = [];
                return;
            }
            try {
                const params = new URLSearchParams({
                    user: this.userId,
                    conversation_id: conversationId,
                    limit: '100'
                });
                const response = await fetch(`${this.getChatBaseUrl()}/messages?${params}`, {
                    method: 'GET',
                    headers: this.getChatHeaders()
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                const apiMessages = data.data || [];
                // 按时间正序排列
                apiMessages.sort((a, b) => a.created_at - b.created_at);
                const formattedMessages = [];
                apiMessages.forEach(msg => {
                    if (msg.query) {
                        formattedMessages.push({
                            content: msg.query,
                            isUser: true
                        });
                    }
                    if (msg.answer) {
                        formattedMessages.push({
                            content: msg.answer,
                            isUser: false,
                            isLoading: false
                        });
                    }
                });
                this.msgList = formattedMessages;
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } catch (error) {
                console.error('获取消息历史失败:', error);
                this.$message.error('获取消息历史失败');
            }
        },
        // 切换到指定会话
        async switchConversation(conv) {
            this.currentConversationId = conv.id;
            this.conversationId = conv.id;
            this.showHistory = false;
            await this.loadConversationMessages(conv.id);
        },
        // 删除指定会话
        deleteConversation(conv) {
            this.$confirm('确定要删除这个对话吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'clear-confirm-dialog'
            }).then(async () => {
                try {
                    const response = await fetch(`${this.getChatBaseUrl()}/conversations/${conv.id}`, {
                        method: 'DELETE',
                        headers: this.getChatHeaders(),
                        body: JSON.stringify({ user: this.userId })
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const index = this.conversations.findIndex(c => c.id === conv.id);
                    if (index !== -1) {
                        this.conversations.splice(index, 1);
                    }
                    // 删除的是当前会话，则开启新对话
                    if (this.currentConversationId === conv.id) {
                        this.startNewChat();
                    }
                    this.$message.success('删除成功');
                } catch (error) {
                    console.error('删除对话失败:', error);
                    this.$message.error('删除失败');
                }
            }).catch(() => {});
        },
        // 开始新对话（清空当前会话状态）
        startNewChat() {
            this.currentConversationId = '';
            this.conversationId = '';
            this.msgList = [];
            this.queryMsg = '';
            this.showHistory = false;
        },
        // 格式化会话时间
        formatConvTime(timestamp) {
            if (!timestamp) return '';
            const t = typeof timestamp === 'number' && timestamp < 1e12 ? timestamp * 1000 : timestamp;
            const date = new Date(t);
            const now = new Date();
            const diff = now - date;
            if (diff < 60000) return '刚刚';
            if (diff < 3600000) return Math.floor(diff / 60000) + '分钟前';
            if (diff < 86400000) return Math.floor(diff / 3600000) + '小时前';
            if (diff < 604800000) return Math.floor(diff / 86400000) + '天前';
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },
        startDrag(e) {
            if (this.isScreen || !this.isOpen) return;
            if (e.button !== 0) return;
            if (e.target.closest('.header-right')) return;

            const panel = this.$refs.aiChatPanel;
            if (!panel) return;

            const rect = panel.getBoundingClientRect();
            if (!this.panelPos) {
                this.panelPos = { left: rect.left, top: rect.top };
            }

            this.dragging = true;
            this.dragStart = { x: e.clientX, y: e.clientY };
            this.panelStart = { left: this.panelPos.left, top: this.panelPos.top };

            document.addEventListener('mousemove', this.onDragMove);
            document.addEventListener('mouseup', this.onDragEnd);
            document.body.style.userSelect = 'none';
            e.preventDefault();
        },
        onDragMove(e) {
            if (!this.dragging) return;
            const panel = this.$refs.aiChatPanel;
            if (!panel) return;

            const dx = e.clientX - this.dragStart.x;
            const dy = e.clientY - this.dragStart.y;
            let left = this.panelStart.left + dx;
            let top = this.panelStart.top + dy;

            const pw = panel.offsetWidth;
            const ph = panel.offsetHeight;
            const maxLeft = Math.max(0, window.innerWidth - pw);
            const maxTop = Math.max(0, window.innerHeight - ph);

            left = Math.min(Math.max(0, left), maxLeft);
            top = Math.min(Math.max(0, top), maxTop);

            this.panelPos = { left, top };
        },
        onDragEnd() {
            if (!this.dragging) return;
            this.dragging = false;
            document.removeEventListener('mousemove', this.onDragMove);
            document.removeEventListener('mouseup', this.onDragEnd);
            document.body.style.userSelect = '';
        },
        toggleFullScreen() {
            this.isScreen = !this.isScreen;
        },
        // 切换聊天框显示/隐藏
        toggleChat() {
            this.isOpen = !this.isOpen;
            this.isScreen=false;
            this.$emit('closeAIChat')
        },

        // 清除所有消息
        clearMessages() {
            if (this.msgList.length === 0) {
                return;
            }
            
            this.$confirm('确定要清除所有对话记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'clear-confirm-dialog'
            }).then(() => {
                this.msgList = [];
                this.$message.success('已清除对话记录');
            }).catch(() => {
                // 用户取消操作
            });
        },

        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                const messagesContainer = document.querySelector('.chat-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            });
        },

        parseMarkdown(text) {
            if (!text) return text;
            if (this.md) {
                return this.md.render(text);
            } else {
                return text;
            }
        },

        async getMsg() {
            if (!this.queryMsg.trim() || !this.isCanSend) return;
            // 发送消息时关闭历史面板
            this.showHistory = false;

            // 添加用户消息
            const userMessage = {
                content: this.queryMsg.trim(),
                isUser: true
            };
            this.msgList.push(userMessage);

            // 滚动到底部
            this.scrollToBottom();
            this.isCanSend = false;

            // 清空输入框
            const query = this.queryMsg.trim();
            this.queryMsg = '';

            try {
                // 添加AI回复占位符
                const aiMessage = {
                    content: '',
                    isUser: false,
                    isLoading: true
                };
                this.msgList.push(aiMessage);

                // 滚动到底部
                this.scrollToBottom();

                const response = await fetch(`${window.global_config.AI_CHAT_URL}/v1/chat-messages`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${window.global_config.AI_API.CHAT_API_KEY}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        query: query,
                        response_mode: "streaming",
                        user: this.userId,
                        files: [],
                        inputs: {},
                        conversation_id: this.conversationId,
                        auto_generate_name: true
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';
                let isNewConversation = false;

                while (true) {
                    const index = this.msgList.length - 1;
                    const { done, value } = await reader.read();
                    if (done) {
                        console.log('流式数据接收完成');
                        break;
                    }

                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();

                    lines.forEach(line => {
                        if (line.startsWith('data:')) {
                            const data = line.substring(5).trim();
                            if (data) {
                                try {
                                    const parsedData = JSON.parse(data);
                                    // 保存会话 ID（首次返回时），实现连续对话
                                    if (parsedData.conversation_id && !this.conversationId) {
                                        this.conversationId = parsedData.conversation_id;
                                        this.currentConversationId = parsedData.conversation_id;
                                        isNewConversation = true;
                                    }
                                    if (parsedData.event == 'message') {
                                        // 首次接收数据时关闭加载状态
                                        if (this.msgList[index].isLoading) {
                                            this.$set(this.msgList[index], 'isLoading', false);
                                        }
                                        if (this.msgList[index].content == '') this.msgList[index].content = '';
                                        this.msgList[index].content += parsedData.answer;
                                        // 滚动到底部（实时滚动，确保长消息也能看到最新内容）
                                        this.scrollToBottom();
                                    } else if (parsedData.event == 'message_end' || parsedData.event == 'workflow_finished') {
                                        // 流结束，关闭加载状态
                                        this.$set(this.msgList[index], 'isLoading', false);
                                    }
                                } catch (e) {
                                    console.error('解析数据失败:', e);
                                }
                            }
                        }
                    });
                }
                // 新会话产生后刷新会话列表，获取会话名称
                if (isNewConversation) {
                    this.loadConversations();
                }
            } catch (error) {
                console.error('请求错误:', error);
                // 显示错误消息
                if (this.msgList.length > 0 && !this.msgList[this.msgList.length - 1].isUser) {
                    const lastMsg = this.msgList[this.msgList.length - 1];
                    this.$set(lastMsg, 'isLoading', false);
                    lastMsg.content = '<div class="error-message"> 抱歉，请求失败，请稍后重试</div>';
                    // 滚动到底部
                    this.scrollToBottom();
                }

            }
            this.isCanSend = true;
        }
    }
}
</script>

<style scoped>
ul{
    list-style: none;
    padding: 0;
    margin: 0;
}
/* 1. 包装器：固定定位在右下角 */
.ai-chat-wrapper {
    position: fixed;
    right: 30px;
    bottom: 20px;
    z-index: 999;
}
.full-screen1 {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    width: 100%;
    z-index: 999;
}

/* 2. 聊天框主体（小窗口：fixed，便于拖拽定位） */
.aiChat {
    position: fixed;
    z-index: 999;
    width: 400px;
    height: 80vh;
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
}
/* 全屏：贴底部横向撑满，预留顶部导航等区域约 70px（left+right 避免 100vw 导致横向滚动条） */
.full-screen {
    left: 0;
    right: 0;
    width: auto;
    height: calc(100vh - 70px);
    bottom: 0;
    top: auto;
    border-radius: 0;
}
.chat-container {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    color: #333333;
}
.chat-container-screen {
    max-height: none;
    height: 100%;
}

/* 3. 头部样式（无修改，仅保持） */
.chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0; /* 防止头部被压缩 */
}
.header-right {
    display: flex;
    align-items: center;
    width: auto;
}
.header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}
.header-left h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}
/* 历史记录入口按钮 */
.history-button {
    font-size: 18px;
    color: #999999;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}
.history-button:hover {
    background-color: #ecf5ff;
    color: #4a90e2;
}
.history-button.is-active {
    background-color: #ecf5ff;
    color: #4a90e2;
}

/* 对话历史面板（覆盖在消息区域上方） */
.history-panel {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    overflow: hidden;
    height: 0;
}
.history-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}
.history-back,
.history-new {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    color: #666666;
    font-size: 16px;
    transition: all 0.3s ease;
}
.history-back:hover,
.history-new:hover {
    background-color: #ecf5ff;
    color: #4a90e2;
}
.history-title {
    font-size: 15px;
    font-weight: 600;
    color: #333333;
}
.history-search {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}
.history-search .el-icon-search {
    color: #999999;
    font-size: 14px;
    margin-right: 8px;
}
.history-search-input {
    flex: 1;
    border: none;
    outline: none;
    background-color: #f0f0f0;
    border-radius: 14px;
    padding: 6px 12px;
    font-size: 13px;
    color: #333333;
}
.history-search-input::placeholder {
    color: #999999;
}
.history-list {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 8px;
}
.history-list::-webkit-scrollbar {
    width: 6px;
}
.history-list::-webkit-scrollbar-track {
    background: transparent;
}
.history-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}
.history-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    margin-bottom: 4px;
}
.history-item:hover {
    background-color: #e8f1fb;
}
.history-item.is-active {
    background-color: #ecf5ff;
}
.history-item-info {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 8px;
}
.history-item-icon {
    color: #4a90e2;
    font-size: 16px;
    flex-shrink: 0;
}
.history-item-text {
    flex: 1;
    min-width: 0;
}
.history-item-name {
    font-size: 13px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
}
.history-item-time {
    font-size: 11px;
    color: #999999;
    margin-top: 2px;
}
.history-item-del {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #999999;
    font-size: 13px;
    flex-shrink: 0;
    opacity: 0;
    transition: all 0.2s ease;
}
.history-item:hover .history-item-del {
    opacity: 1;
}
.history-item-del:hover {
    background-color: #fef0f0;
    color: #f56c6c;
}
.history-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #999999;
    gap: 12px;
}
.history-empty .el-icon-chat-dot-round {
    font-size: 40px;
    color: #cccccc;
}
.history-empty span {
    font-size: 13px;
}

.chat-header--draggable {
    cursor: move;
}

.chat-header--draggable .header-right {
    cursor: default;
}

.minimize-button {
    background: none;
    border: none;
    color: #999999;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.minimize-button:hover {
    background-color: #f0f0f0;
    color: #666666;
}

/* 清除按钮样式 */
.clear-button {
    font-size: 18px;
    color: #999999;
    cursor: pointer;
    padding: 6px;
    margin-right: 5px;
    border-radius: 4px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.clear-button:hover {
    background-color: #fef0f0;
    color: #f56c6c;
}

/* 4. 消息区域：Flex:1 填充剩余空间，强制撑满 */
.chat-messages {
    flex: 1 1 auto; /* 关键：填充header和input-area之外的所有空间 */
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 0; /* 配合flex:1，强制触发剩余空间填充（解决部分浏览器兼容） */
}

.system-message {
    align-self: center;
    background-color: #e8e8e8;
    color: #666666;
    padding: 8px 16px;
    border-radius: 16px;
    font-size: 14px;
    margin: 10px 0;
}

.message-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.user-message {
    align-self: flex-end;
    max-width: 70%;
}

.ai-message {
    align-self: flex-start;
    max-width: 70%;
}

.message-content {
    padding: 12px 16px;
    border-radius: 18px;
    line-height: 1.5;
    font-size: 14px;
}

.user-message .message-content {
    background-color: #4a90e2;
    color: #ffffff;
    border-bottom-right-radius: 4px;
}

.ai-message .message-content {
    background-color: #ffffff;
    color: #333333;
    border-bottom-left-radius: 4px;
    border: 1px solid #e0e0e0;
}

/* 5. 输入区域：固定在底部，不压缩 */
.chat-input-area {
    padding: 10px;
    background-color: #ffffff;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 10px;
    align-items: center;
    flex-shrink: 0; /* 防止输入框被压缩 */
}

.input-container {
    flex: 1;
    position: relative;
}

.chat-input {
    width: 100%;
    min-height: 48px;
    max-height: 150px;
    padding: 12px 16px;
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    border-radius: 24px;
    color: #333333;
    resize: none;
    font-size: 16px;
    line-height: 20px;
    transition: all 0.3s ease;
}

.chat-input:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    background-color: #ffffff;
}

.chat-input::placeholder {
    color: #999999;
}

.send-button {
    background-color: #4a90e2;
    color: #ffffff;
    border: none;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.send-button:hover {
    background-color: #3a80d2;
    transform: scale(1.05);
}

.send-button:active {
    transform: scale(0.95);
}

.send-icon {
    font-size: 18px;
    font-weight: bold;
}

/* 滚动条样式 */
.chat-messages::-webkit-scrollbar {
    width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
}

/* Markdown样式 */
::v-deep .ai-message .message-content h1,
::v-deep .ai-message .message-content h2,
::v-deep .ai-message .message-content h3,
::v-deep .ai-message .message-content h4,
::v-deep .ai-message .message-content h5,
::v-deep .ai-message .message-content h6 {
    font-weight: 600;
    line-height: 1.3;
    color: #1a1a1a;
}

/* H1 - 最大标题，间距最大 */
::v-deep  .ai-message .message-content h1 {
    font-size: 24px;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 12px;
    margin-top: 36px;
    margin-bottom: 20px;
}

/* H2 - 二级标题，间距较大 */
::v-deep .ai-message .message-content h2 {
    font-size: 20px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
    margin-top: 32px;
    margin-bottom: 16px;
}

/* H3 - 三级标题，间距适中 */
::v-deep .ai-message .message-content h3 {
    font-size: 18px;
    margin-top: 28px;
    margin-bottom: 14px;
}

/* H4 - 四级标题，间距较小 */
::v-deep .ai-message .message-content h4 {
    font-size: 16px;
    margin-top: 24px;
    margin-bottom: 12px;
}

/* H5/H6 - 小标题，间距最小 */
::v-deep .ai-message .message-content h5,
::v-deep .ai-message .message-content h6 {
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 10px;
}

::v-deep .ai-message .message-content p {
    margin:0;
    line-height: 1.8;
}

::v-deep .ai-message .message-content p + p {
    margin-top: 20px;
}

/* 标题后的第一个段落间距减小 */
::v-deep .ai-message .message-content h1 + p,
::v-deep .ai-message .message-content h2 + p,
::v-deep .ai-message .message-content h3 + p,
::v-deep .ai-message .message-content h4 + p,
::v-deep .ai-message .message-content h5 + p,
::v-deep .ai-message .message-content h6 + p {
    margin-top: 12px;
}

::v-deep .ai-message .message-content ul,
::v-deep .ai-message .message-content ol {
    margin: 18px 0;
    padding-left: 24px;
}

/* 标题后的列表间距减小 */
::v-deep .ai-message .message-content h1 + ul,
::v-deep .ai-message .message-content h2 + ul,
::v-deep .ai-message .message-content h3 + ul,
::v-deep .ai-message .message-content h4 + ul,
::v-deep .ai-message .message-content h5 + ul,
::v-deep .ai-message .message-content h6 + ul,
::v-deep .ai-message .message-content h1 + ol,
::v-deep .ai-message .message-content h2 + ol,
::v-deep .ai-message .message-content h3 + ol,
::v-deep .ai-message .message-content h4 + ol,
::v-deep .ai-message .message-content h5 + ol,
::v-deep .ai-message .message-content h6 + ol {
    margin-top: 12px;
}

::v-deep .ai-message .message-content ul + ul,
::v-deep .ai-message .message-content ol + ol,
::v-deep .ai-message .message-content ul + ol,
::v-deep .ai-message .message-content ol + ul {
    margin-top: 16px;
}

::v-deep .ai-message .message-content li {
    margin: 10px 0;
    line-height: 1.8;
}

::v-deep .ai-message .message-content li > ul,
::v-deep .ai-message .message-content li > ol {
    margin-top: 10px;
    margin-bottom: 10px;
}

::v-deep .ai-message .message-content strong {
    font-weight: 600;
    color: #1a1a1a;
}

::v-deep .ai-message .message-content em {
    font-style: italic;
    color: #555;
}

::v-deep .ai-message .message-content code {
    background-color: #f6f8fa;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: "Consolas", "Monaco", "Courier New", monospace;
    font-size: 13px;
    color: #e96900;
    border: 1px solid #e1e4e8;
}

::v-deep .ai-message .message-content p > code {
    margin: 0 2px;
}

::v-deep .ai-message .message-content pre {
    background-color: #f6f8fa;
    padding: 16px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 24px 0;
    border: 1px solid #e1e4e8;
}

/* 标题后的代码块间距减小 */
::v-deep .ai-message .message-content h1 + pre,
::v-deep .ai-message .message-content h2 + pre,
::v-deep .ai-message .message-content h3 + pre,
::v-deep .ai-message .message-content h4 + pre,
::v-deep .ai-message .message-content h5 + pre,
::v-deep .ai-message .message-content h6 + pre {
    margin-top: 14px;
}

::v-deep .ai-message .message-content pre code {
    background-color: transparent;
    padding: 0;
    border: none;
    color: #24292e;
}

::v-deep .ai-message .message-content blockquote {
    border-left: 4px solid #4a90e2;
    padding: 12px 16px;
    margin: 24px 0;
    color: #666666;
    background-color: #f8f9fa;
    border-radius: 0 4px 4px 0;
}

/* 标题后的引用块间距减小 */
::v-deep .ai-message .message-content h1 + blockquote,
::v-deep .ai-message .message-content h2 + blockquote,
::v-deep .ai-message .message-content h3 + blockquote,
::v-deep .ai-message .message-content h4 + blockquote,
::v-deep .ai-message .message-content h5 + blockquote,
::v-deep .ai-message .message-content h6 + blockquote {
    margin-top: 14px;
}

::v-deep .ai-message .message-content a {
    color: #4a90e2;
    text-decoration: none;
    border-bottom: 1px dotted #4a90e2;
}

::v-deep .ai-message .message-content a:hover {
    text-decoration: underline;
    border-bottom: 1px solid #4a90e2;
}

::v-deep .ai-message .message-content img {
    max-width: 100%;
    border-radius: 8px;
    margin: 12px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

::v-deep .ai-message .message-content table {
    border-collapse: collapse;
    width: 100%;
    margin: 24px 0;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 标题后的表格间距减小 */
::v-deep .ai-message .message-content h1 + table,
::v-deep .ai-message .message-content h2 + table,
::v-deep .ai-message .message-content h3 + table,
::v-deep .ai-message .message-content h4 + table,
::v-deep .ai-message .message-content h5 + table,
::v-deep .ai-message .message-content h6 + table {
    margin-top: 14px;
}

::v-deep .ai-message .message-content th,
::v-deep .ai-message .message-content td {
    border: 1px solid #e1e4e8;
    padding: 10px 14px;
    text-align: left;
}

::v-deep .ai-message .message-content th {
    background-color: #f6f8fa;
    font-weight: 600;
    color: #24292e;
}

::v-deep .ai-message .message-content td {
    background-color: #ffffff;
    color: #333333;
}

::v-deep .ai-message .message-content tr:nth-child(even) {
    background-color: #fafbfc;
}

::v-deep .ai-message .message-content hr {
    border: none;
    border-top: 2px solid #e1e4e8;
    margin: 20px 0;
}

/* 加载动画 */
.loading-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
}

.loading-dot {
    width: 8px;
    height: 8px;
    background-color: #4a90e2;
    border-radius: 50%;
    animation: loading-bounce 1.4s ease-in-out infinite both;
}

.loading-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes loading-bounce {
    0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.5;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 错误提示 */
.error-message {
    color: #f56c6c;
    background-color: #fef0f0;
    padding: 12px 16px;
    border-radius: 8px;
    border-left: 4px solid #f56c6c;
}

/* AI内容包装器 */
.ai-content-wrapper {
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
}

/* 清除确认对话框样式 - 提高层级 */
::v-deep .clear-confirm-dialog {
    z-index: 99999 !important;
}

::v-deep .clear-confirm-dialog + .v-modal {
    z-index: 99998 !important;
}

/* 触发按钮 */
.chat-trigger {
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 56px;
    height: 56px;
    background-color: #4a90e2;
    color: #ffffff;
    border: none;
    border-radius: 50%;
    box-shadow: 0 4px 16px rgba(74, 144, 226, 0.4);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    transition: all 0.3s ease;
    z-index: 10000;
}

.chat-trigger:hover {
    background-color: #3a80d2;
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(74, 144, 226, 0.5);
}

.chat-trigger:active {
    transform: scale(0.95);
}

/* 聊天框显示时隐藏触发按钮 */
.aiChat + .chat-trigger {
    display: none;
}
</style> 